import colors from '../colors';
import { FontTheme } from './types';
import variants from './variants';
import weights from './weights';

const font: FontTheme = {
    variants,
    weights,
    defaults: {
        color: colors.black,
        variant: 'p',
        fontFamily: 'Roboto, sans-serif'
    }
};

export default font;
